
<template>
   <v-layout v-if="confirmer.active" row justify-center>
      <v-dialog :value="confirmer.active" persistent max-width="600">
         <v-card>
         <v-card-title class="headline grey lighten-2">{{confirmer.title}}</v-card-title>
         <v-card-text v-if="confirmer.body">{{confirmer.body}}</v-card-text>
         <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat
                   @click.native="answer(choice.value)"
                   v-for="(choice, index) in confirmer.choices" :key="index">
               {{choice.text}}
            </v-btn>
         </v-card-actions>
         </v-card>
      </v-dialog>
   </v-layout>
</template>

<script>
export default {
   computed: {
      confirmer() {
         return this.$store.state.confirmer
      }
   },
   methods: {
      answer(value) {
         this.confirmer.resolve(value)
         this.$store.commit('confirmer/DEACTIVATE')
      },
   }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// ConfirmDialog.vue?7028172a